var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXIcon24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22676 4.2257C4.50161 3.95212 4.93172 3.92725 5.2348 4.15109L5.32163 4.2257L12 10.8727L18.6784 4.2257C18.9532 3.95212 19.3833 3.92725 19.6864 4.15109L19.7732 4.2257C20.0481 4.49928 20.0731 4.92739 19.8482 5.22907L19.7732 5.3155L12.5474 12.5078C12.2726 12.7814 11.8425 12.8062 11.5394 12.5824L11.4526 12.5078L4.22676 5.3155C3.92441 5.01456 3.92441 4.52664 4.22676 4.2257Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7732 19.7743C19.4984 20.0479 19.0683 20.0727 18.7652 19.8489L18.6784 19.7743L12 13.1273L5.32163 19.7743C5.04677 20.0479 4.61667 20.0727 4.31359 19.8489L4.22676 19.7743C3.9519 19.5007 3.92691 19.0726 4.1518 18.7709L4.22676 18.6845L11.4526 11.4922C11.7274 11.2186 12.1575 11.1938 12.4606 11.4176L12.5474 11.4922L19.7732 18.6845C20.0756 18.9854 20.0756 19.4734 19.7732 19.7743Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon24);
export default __webpack_public_path__ + "static/media/x-icon-24.3f903e05c528acc5fd37b132fff6ebf4.svg";
export { ForwardRef as ReactComponent };